import React from 'react';

/**
 * Bulk row selection controls for Creator Intelligence / Top performers tables.
 */
export default function PerfHubCreatorSelectToolbar({
  visibleCount,
  selectedCount,
  onSelectAll,
  onClear,
  onBulkShortlist,
  busy,
}) {
  if (!visibleCount) return null;

  const allSelected = visibleCount > 0 && selectedCount >= visibleCount;
  const someSelected = selectedCount > 0 && selectedCount < visibleCount;

  return (
    <div className="ph-creator-select-bar">
      <label className="ph-creator-select-all">
        <input
          type="checkbox"
          className="ph-creator-row-check"
          checked={allSelected}
          ref={(el) => {
            if (el) el.indeterminate = someSelected;
          }}
          disabled={busy}
          onChange={(e) => {
            if (e.target.checked) onSelectAll();
            else onClear();
          }}
        />
        <span>
          {allSelected ? 'Deselect all' : 'Select all'} ({visibleCount})
        </span>
      </label>
      {selectedCount > 0 && (
        <div className="ph-creator-select-actions">
          <span className="ph-creator-select-count">{selectedCount} selected</span>
          <button type="button" className="btn-outline ph-btn-select-clear" disabled={busy} onClick={onClear}>
            Clear
          </button>
          <button
            type="button"
            className="btn-primary ph-btn-select-shortlist"
            disabled={busy}
            onClick={onBulkShortlist}
          >
            Add to shortlist ({selectedCount})
          </button>
        </div>
      )}
    </div>
  );
}
